import React from 'react';
import { PeekBox, PeekButton } from '@piiqtechnologies/ui-components';
import { Image } from '@piiqtechnologies/svg-icons';

const ExtractPhoto = ({ openExtractPhotoTool }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(PeekBox, null,
            React.createElement(PeekButton, { onClick: openExtractPhotoTool, "aria-label": "Extract photo", variant: "contained", startIcon: React.createElement(Image, null) }, "Extract Photo"))));
};

export { ExtractPhoto, ExtractPhoto as default };
